// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__16uGv","label":"Category_label__2_StF","content":"Category_content__ScC-L","header":"Category_header__SGldm","location":"Category_location__1-9gv"};